import * as React from "react";
import { HeaderLogoAndTel } from "../../../HeaderLogoAndTel";
import * as main from "../styles/main.module.scss";
import * as screen1 from "../styles/screen1sub.module.scss"

export const Screen1Sub = ({price="за 1 ₽"}) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel />
        <div className={screen1.screen1__wrapper}>
          <img src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_vashih_celey/nya-phone.png"
               className={screen1.screen1__img} alt={''}/>
          <div className={screen1.screen1__info}>
            <h1 className={screen1.screen1__title}>Выучи английский язык<br/>за&nbsp;3&nbsp;месяца</h1>
            <p className={screen1.screen1__date}>Только на&nbsp;этой&nbsp;неделе</p>
            <p className={screen1.screen1__desc}>Получи <strong>полный</strong> доступ к&nbsp;курсу</p>
            <div className={screen1.screen1__prices}>
              <span className={screen1.screen1__pricesNew}>{price}</span>
            </div>
            <a href="#widget" className={`${main.mainBtn} ${screen1.mainBtn}`}>Попробовать</a>
          </div>
        </div>
      </div>
    </header>
  );
}
